module.exports = __webpack_public_path__ + "img/WhiteOaksLogoBlack.c5fb0f27.jpg";